

















































































































































































































































































import { Component } from 'vue-property-decorator';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Conecta/Clientes/FiltrosBusqueda.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import { save_report } from '@/pantallas/Informes/partes/fetchSaveReport';
import { postReporteTime } from '@/pantallas/Informes/partes/postReporteTime';
import MensajeValidacionHRef from '@/pantallas/Informes/partes/MensajeValidacionHRef.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import axios from 'axios';
import MensajeValidacion from '../../../reusable/Mantenedor/MensajeValidacion.vue';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  ProcessCellForExportParams,
  CsvExportParams,
  ValueFormatterParams,
  ICellRendererParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';
import {
  checkboxColumnDef,
  makeAccionesColumnDef_DEPRECATED,
  creadoPorColumnDefs,
  modificadoPorColumnDefs,
  fechaCreacionColumnDefs,
  fechaModificacionColumnDefs,
} from '@/reusable/Grid/aggridColumnDefUtils';
import { LoadingService } from '@/services/loadingService';
import HandleErrors from '@/config/handleErrors'; //
import { ComponenteBase, Accion } from '@/views/base/ComponenteBase';
import moment from 'moment';
import {
  codigoAccionesMenuItem,
  CodigoAccion,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import {
  fetchHistorico,
  fetchTarifas,
  fetchVehiculos,
  fetchFlotas,
  fetchPeajes,
  fetchRutas,
  fetchCount,
  MsResponseData,
} from '@/pantallas/Peajes/Mapa/fetchData';
import VerDetalleModal from '@/pantallas/Peajes/Tarifas/VerDetalleModal.vue';
import { toInteger } from 'lodash';

@Component({
  components: {
    MantenedorGridSinCodigo,
    FiltrosBusqueda,
    VerDetalleModal,
    DatePicker,
    TimePicker,
    MensajeValidacion: MensajeValidacionHRef,
    FormFieldsContainer,
    AgGridVue,
  },
})
export default class MapaPantalla extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.ReportesPeajes;
  loadingService = new LoadingService();

  requestsStart: number = 0;
  isFormValid: boolean = false;
  MsResponseData: MsResponseData = null;
  detalleSeleccionado: any = null;
  // peajeSeleccionado: number = 0;
  mostrarModalVerDetalle: boolean = false;
  infoItems: any[] = [];
  dataInforme: any = null;
  infoTypeReport: string = '';
  showInfoDialog: boolean = false;
  verDetalle: boolean = false;
  buscarPeaje: string = '';
  fechaDesde: any = moment(new Date()).add(-1, 'days');
  fechaHasta: any = moment();
  horaDesde: any = moment('00:00', 'HHmm');
  horaHasta: any = moment('23:59', 'HHmm');
  vehiculos: any[] = [];
  flotas: any[] = [];
  peajes: any[] = [];
  rutas: any[] = [];
  params: any[] = [];
  flotasSeleccionados: any[] = [];
  vehiculosSeleccionados: any[] = [];
  peajesSeleccionados: any[] = [];
  rutasSeleccionados: any[] = [];
  showBtnCancelar: boolean = false;
  showValidacionReporteRestricciones: boolean = false;
  tituloValidacion: string = '';
  mensajeValidacion: string = '';
  row: string = 'pdf';
  mensajeValidacionBot: string = '';
  mensajeHRef: any = null;
  showValidacionReporteTime: boolean = false;
  checkAllFlotas: boolean = false;
  checkAllVehiculos: boolean = false;
  checkAllPeajes: boolean = false;
  checkAllRutas: boolean = false;
  mapa: any = '';

  gridApi: GridApi = null;
  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'ID',
        field: 'id_peaje_historico',
        hide: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Nombre Peaje',
        field: 'nom_peaje',
        cellStyle: { textAlign: 'left' },
        width: 320,
      },
      {
        headerName: 'Ruta',
        field: 'nom_ruta',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Patente',
        field: 'patente',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Precio',
        field: 'val_precio',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Tipo Tarifa',
        field: 'nom_tipotarifa',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha ',
        field: 'val_fechahoraactividad',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Ubicación',
        field: 'val_ubicacion',
        cellStyle: { textAlign: 'left' },
      },
      // {
      //   headerName: 'Aplicaciones',
      //   field: 'aplicaciones',
      //   cellStyle: { textAlign: 'left' },
      //   type: 'medalColumn',
      //   tooltipField: 'country',
      //   cellRenderer: () => {
      //     return '<i class="material-icons" id="5545" title="Ver Filtros" style="width: 28px; height: 28px; margin-top: 10%" >info_outlined</i>';
      //   },
      //   onCellClicked: this.handleClickInfo,
      //   columnGroupShow: 'closed',
      // },
    ].map(x => ({
      width: 250,
      hide: false,
      ...x,
    })),
    pagination: true,
    paginationPageSize: 5,
    onGridReady: this.handleGridReady,
    onModelUpdated: this.onModelUpdated,
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
  };

  mounted() {
    const cliente = localStorage.clienteDefecto;
    this.buscarHistorico(cliente, '');
    this.buscarFlotas();
    // this.buscarPeajes();
    this.buscarRutas();
  }

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    const cliente = localStorage.clienteDefecto;
    this.buscarHistorico(cliente, '');
    this.buscarFlotas();
    // this.buscarPeajes();
    this.buscarRutas();
    // this.buscarVehiculos();
  }
  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
  accionesTotales: PermisoAccion[] = [];

  showLoading() {
    this.requestsStart += 1;
    if (this.requestsStart == 1) {
      this.loadingService.showLoading();
    }
  }
  hideLoading() {
    this.requestsStart -= 1;
    if (this.requestsStart == 0) {
      this.loadingService.hideLoading();
    }
  }

  fetchHistorico(id: string, rut: string) {
    this.showLoading();
    return fetchHistorico(id, rut)
      .catch(error => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'las facturaciones',
          })
        );
        return;
      })
      .finally(() => this.hideLoading());
  }

  fetchVehiculos(flotas: any) {
    this.showLoading();
    return fetchVehiculos(flotas)
      .catch(error => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'las facturaciones',
          })
        );
        return;
      })
      .finally(() => this.hideLoading());
  }

  fetchFlotas() {
    this.showLoading();
    return fetchFlotas(localStorage.clienteDefecto)
      .catch(error => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'las facturaciones',
          })
        );
        return;
      })
      .finally(() => this.hideLoading());
  }

  fetchPeajes(peajes: any) {
    this.showLoading();
    return fetchPeajes(peajes)
      .catch(error => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'los peajes',
          })
        );
        return;
      })
      .finally(() => this.hideLoading());
  }
  fetchCount(peajes: any) {
    this.showLoading();
    return fetchCount(peajes)
      .catch(error => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'las actividades',
          })
        );
        return;
      })
      .finally(() => this.hideLoading());
  }

  fetchRutas() {
    this.showLoading();
    return fetchRutas()
      .catch(error => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'las facturaciones',
          })
        );
        return;
      })
      .finally(() => this.hideLoading());
  }

  async buscarHistorico(id: string, rut: string) {
    this.MsResponseData = (await this.fetchHistorico(id, rut)) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (this.MsResponseData.data.length > 0) {
          this.gridApi.setRowData(this.MsResponseData.data);
        } else {
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        }
      } else {
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  async buscarVehiculos(flotas: any) {
    this.MsResponseData = (await this.fetchVehiculos(flotas)) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (this.MsResponseData.data.length > 0) {
          this.vehiculos = this.MsResponseData.data;
        } else {
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        }
      } else {
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  downloadFile() {
    var client = localStorage.clienteDefecto;
    var user = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user')).id
      : '';
    var fecha_ini = this.fechaDesde.format('YYYY-MM-DD');
    var fecha_fin = this.fechaHasta.format('YYYY-MM-DD');
    // window.open(_url_base + 'mapa_peajes?patente='+this.vehiculosSeleccionados+'&fecha=2023-06-08&client='+client+'&user='+user+'&fecha_fin='+fecha_fin+'&fecha_ini='+fecha_ini)
    var json = {
      patente: this.vehiculosSeleccionados,
      client: client,
      user: user,
      fecha_ini: fecha_ini,
      fecha_fin: fecha_fin,
      hora_ini: this.horaDesde.format('HH:mm:ss'),
      hora_fin: this.horaHasta.format('HH:mm:ss'),
    };

    this.buscarActividades(json);
  }

  async buscarFlotas() {
    this.MsResponseData = (await this.fetchFlotas()) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (this.MsResponseData.data.length > 0) {
          this.flotas = this.MsResponseData.data;
        } else {
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        }
      } else {
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  async buscarPeajes(peajes: any) {
    this.MsResponseData = (await this.fetchPeajes(peajes)) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (this.MsResponseData.data.length > 0) {
          this.peajes = [];
          for (
            let index = 0;
            index < this.MsResponseData.data.length;
            index++
          ) {
            this.peajes.push(this.MsResponseData.data[index]['nom_peaje']);
          }
        } else {
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        }
      } else {
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  async buscarActividades(peajes: any) {
    this.MsResponseData = (await this.fetchCount(peajes)) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (
          toInteger(this.MsResponseData.data) > 0 &&
          toInteger(this.MsResponseData.data) < 1500
        ) {
          let _url_base = process.env.VUE_APP_SERVICIO_MS;
          window.open(
            _url_base +
              'mapa_peajes?patente=' +
              this.vehiculosSeleccionados +
              '&fecha=2023-06-08&client=' +
              peajes.client +
              '&user=' +
              peajes.user +
              '&fecha_fin=' +
              peajes.fecha_fin +
              '&fecha_ini=' +
              peajes.fecha_ini +
              '&hora_ini=' +
              peajes.hora_ini +
              '&hora_fin=' +
              peajes.hora_fin
          );
        } else if (toInteger(this.MsResponseData.data) == 0) {
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        } else {
          this.$snotify.error(
            'La cantidad de registros es demasiado grande, por favor seleccione un intervalo menor.',
            {
              timeout: 3000,
            }
          );
        }
      } else {
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  async buscarRutas() {
    this.MsResponseData = (await this.fetchRutas()) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (this.MsResponseData.data.length > 0) {
          for (
            let index = 0;
            index < this.MsResponseData.data.length;
            index++
          ) {
            this.rutas.push(this.MsResponseData.data[index]['nom_ruta']);
          }
        } else {
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        }
      } else {
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  handleClickInfo(event: any) {
    var itemsInfo: any[] = [];
    if (event.value != '' && event.value != undefined && event.value != null) {
      for (var key in event.value) {
        if (event.value.hasOwnProperty(key)) {
          itemsInfo.push({ key: key, value: event.value[key].appname });
        }
      }
    }
    if (itemsInfo.length == 0) {
      itemsInfo.push({ key: 1, value: 'Sin Aplicaciones' });
    }
    this.infoItems = itemsInfo;
    this.infoTypeReport = event.data.nombre_reporte;
    this.showInfoDialog = true;
  }

  onFilterPeajes() {
    if (this.buscarPeaje.length > 1) {
      this.gridApi.setQuickFilter(this.buscarPeaje);
    } else {
      this.gridApi.setQuickFilter('');
    }
  }

  preventEnter(event: any) {
    if (event.key == 'Enter') {
      event.preventDefault();
    }
  }

  filtroForm(filtros: any) {
    this.buscarHistorico('', filtros.rut.value);
  }
  // handleVerDetalleClick(params: ICellRendererParams) {
  //   this.verDetalle = true;
  //   this.detalleSeleccionado = params.data;
  //   this.peajeSeleccionado = this.detalleSeleccionado.id_peaje;
  //   this.buscarTarifas(this.detalleSeleccionado.id_peaje);
  // }

  // handleEditarClick(params: ICellRendererParams) {
  //   this.verDetalle = false;
  //   this.detalleSeleccionado = params.data;
  //   this.peajeSeleccionado = this.detalleSeleccionado.id_peaje;
  //   this.buscarTarifas(this.detalleSeleccionado.id_peaje);
  // }

  async buscarTarifas(id: number) {
    this.MsResponseData = (await this.fetchTarifas(id)) || null;
    if (this.MsResponseData !== null) {
      if (this.MsResponseData.CODIGO_RESPUESTA == '1') {
        if (this.MsResponseData.data.length > 0) {
          this.detalleSeleccionado = this.MsResponseData.data;
          this.mostrarModalVerDetalle = true;
        } else {
          this.$snotify.error('No se han encontrado registros.', {
            timeout: 3000,
          });
        }
      } else {
        this.$snotify.error(this.MsResponseData.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  fetchTarifas(id_peaje: number) {
    this.showLoading();
    return fetchTarifas(id_peaje)
      .catch(error => {
        this.$snotify.error(
          this.$t('mensajes.mensajesError.consulta', {
            entidad: 'las facturaciones',
          })
        );
        return;
      })
      .finally(() => this.hideLoading());
  }

  handleCierreModalVerDetalle() {
    this.mostrarModalVerDetalle = false;
    this.buscarHistorico('', '');
  }
  clearForm() {
    this.buscarHistorico('', '');
  }

  constructor() {
    super();
    // actionsEvent.onEditar(this.handleEditarClick);
    // actionsEvent.onVerDetalle(this.handleVerDetalleClick);
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    //@ts-ignore
    if (this.gridApi.rowModel.rowsToDisplay.length == 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      this.gridApi.hideOverlay();
    }
  }

  textoComprimido(item: any) {
    let retorno: string = '';
    if (item.length > 14) {
      retorno = item.substr(0, 30) + '...';
    } else {
      retorno = item;
    }
    return retorno;
  }

  async generarReporte() {
    let f = [];
    for (let index = 0; index < this.flotasSeleccionados.length; index++) {
      f.push({ nombre: this.flotasSeleccionados[index] });
    }
    let v = [];
    for (let index = 0; index < this.vehiculosSeleccionados.length; index++) {
      v.push({ unidad: this.vehiculosSeleccionados[index] });
    }
    // if(f.length == 0 || v.length == 0 || this.peajesSeleccionados.length == 0 || this.peajesSeleccionados.length == 0){
    //     this.$snotify.error("Por Favor Complete Todos los Campos");
    //     return;
    // }
    var valid = await this.$validator.validateAll();
    if (!valid) {
      console.log('return');
      return;
    }
    this.dataInforme = {
      vehiculos_seleccionados: {
        flotas: f,
        vehiculos: v,
        etiquetas: '',
      },
      vehiculos: this.vehiculosSeleccionados,
      peajes: this.peajesSeleccionados,
      rutas: this.rutasSeleccionados,
      starting_date: this.fechaDesde.format('DD-MM-YYYY').toString(),
      starting_hour: this.horaDesde.format('HH:mm').toString(),
      ending_date: this.fechaHasta.format('DD-MM-YYYY').toString(),
      ending_hour: this.horaHasta.format('HH:mm').toString(),
      user: localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user')).id
        : '',
      client: localStorage.clienteDefecto,
      report_type: 'peajes',
      nombreReporte: 'Peajes',
      formato: this.row,
      date_created: moment().utcOffset(0, true),
      hidden_columns: [],
      orientation: 'Portrait',
    };
    console.log(this.dataInforme);
    this.aceptaGeneraInforme(true);
  }

  aceptaGeneraInforme(val: any) {
    this.showBtnCancelar = false;
    this.showValidacionReporteRestricciones = false;
    if (val) {
      this.loadingService.showLoading();
      const res = postReporteTime(this.dataInforme, this.row)
        .then(async (resMin: any) => {
          const response = save_report(this.dataInforme, this.row)
            .then(async (response: any) => {
              if ('id_reporte' in response.data) {
                this.tituloValidacion = 'Informe Creado';
                this.mensajeValidacion =
                  'El informe ID ' +
                  response.data.id_reporte +
                  ' se ha solicitado exitosamente.';
                this.mensajeValidacionBot =
                  'Estará disponible en unos segundos en Histórico Informes.';
                this.mensajeHRef = '/informe-generado';
                this.showValidacionReporteRestricciones = true;
              } else {
                this.tituloValidacion = 'Error Generar Informe';
                this.mensajeValidacion =
                  'Hubo un error a la hora de generar el informe';
                this.showValidacionReporteRestricciones = true;
              }
            })
            .catch(() => {
              this.tituloValidacion = 'Error Generar Informe';
              this.mensajeValidacion =
                'Hubo un error a la hora de generar el informe';
              this.showValidacionReporteRestricciones = true;
              this.loadingService.hideLoading();
            })
            .finally(() => {
              this.loadingService.hideLoading();
            });
        })
        .finally(() => {
          this.loadingService.hideLoading();
        });
    }
  }

  selectAllFlota() {
    if (this.checkAllFlotas === true) {
      this.flotas.forEach((x: any) => {
        const existe: boolean = this.flotasSeleccionados.some(a => a === x);
        if (existe === false) {
          this.flotasSeleccionados.push(x.cod_flota);
        }
      });
    } else {
      this.flotasSeleccionados = [];
    }
    this.buscarVehiculos(this.flotasSeleccionados);
  }

  selectAllVehiculo() {
    if (this.checkAllVehiculos === true) {
      this.vehiculos.forEach((x: any) => {
        const existe: boolean = this.vehiculosSeleccionados.some(a => a === x);
        if (existe === false) {
          this.vehiculosSeleccionados.push(x);
        }
      });
    } else {
      this.vehiculosSeleccionados = [];
    }
  }

  selectAllPeajes() {
    if (this.checkAllPeajes === true) {
      this.peajes.forEach((x: any) => {
        const existe: boolean = this.peajesSeleccionados.some(a => a === x);
        if (existe === false) {
          this.peajesSeleccionados.push(x);
        }
      });
    } else {
      this.peajesSeleccionados = [];
    }
  }
  selectAllRutas() {
    if (this.checkAllRutas === true) {
      this.rutas.forEach((x: any) => {
        const existe: boolean = this.rutasSeleccionados.some(a => a === x);
        if (existe === false) {
          this.rutasSeleccionados.push(x);
        }
      });
    } else {
      this.rutasSeleccionados = [];
    }
    this.buscarPeajes(this.rutasSeleccionados);
  }

  get fechaMaxima() {
    const fechaMax = moment().format('YYYY-MM-DD h:mm:ss a');
    return fechaMax;
  }
}
